// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".7e6fd9e6a80834af2752a893f765cd459cffbd36.chunk.js";
};